const sessionStoragePlugin = (store) => {
  store.subscribe((mutation, state) => {
    sessionStorage.setItem("TerraApiStore", JSON.stringify(state));
  });
};

export default sessionStoragePlugin;
